import { ReactSVG } from "react-svg";

export const Logo = () => {
  return <ReactSVG src="logo.svg" width={200} height={100} />;
};
